import { Link } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbSeparator,
  BreadcrumbPage,
} from "@/components/ui/breadcrumb";
import StructuredData from "@/components/StructuredData";
import { getBreadcrumbSchema } from "@/utils/seoSchemas";

export interface BreadcrumbItem {
  label: string;
  path?: string; // optional - last item has no link
}

interface PageBreadcrumbsProps {
  items: BreadcrumbItem[];
}

const PageBreadcrumbs = ({ items }: PageBreadcrumbsProps) => {
  // Create breadcrumb schema for SEO
  const breadcrumbSchema = getBreadcrumbSchema(
    items.map(item => ({
      name: item.label,
      url: item.path ? `https://praxis-versichert.de${item.path}` : undefined
    }))
  );

  return (
    <>
      <StructuredData data={breadcrumbSchema} />
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 pt-4 sm:pt-6 pb-4 sm:pb-6 relative z-20 overflow-x-auto">
      <Breadcrumb>
        <BreadcrumbList className="flex-nowrap whitespace-nowrap">
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            
            return (
              <div key={index} className="inline-flex items-center">
                <BreadcrumbItem className="inline-flex">
                  {isLast || !item.path ? (
                    <BreadcrumbPage className="truncate max-w-[200px] sm:max-w-none">
                      {item.label}
                    </BreadcrumbPage>
                  ) : (
                    <BreadcrumbLink asChild>
                      <Link to={item.path}>{item.label}</Link>
                    </BreadcrumbLink>
                  )}
                </BreadcrumbItem>
                {!isLast && <BreadcrumbSeparator className="shrink-0" />}
              </div>
            );
          })}
        </BreadcrumbList>
      </Breadcrumb>
    </div>
    </>
  );
};

export default PageBreadcrumbs;
